// ─── Gallery filters ──────────────────────────────────────────────────────────
const filterBtns  = document.querySelectorAll('.gallery-filter');
const galleryGroups = document.querySelectorAll('.gallery-group');

if (filterBtns.length) {
  filterBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const filter = btn.dataset.filter;

      filterBtns.forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      galleryGroups.forEach((group) => {
        if (filter === 'all' || group.dataset.category === filter) {
          group.hidden = false;
        } else {
          group.hidden = true;
        }
      });
    });
  });
}

// ─── Lightbox ─────────────────────────────────────────────────────────────────
const lightbox   = document.getElementById('lightbox');
const lbImg      = lightbox?.querySelector('.lightbox__img');
const lbClose    = lightbox?.querySelector('.lightbox__close');
const lbPrev     = lightbox?.querySelector('.lightbox__prev');
const lbNext     = lightbox?.querySelector('.lightbox__next');

let currentGroup  = [];
let currentIndex  = 0;

function openLightbox(links, index) {
  currentGroup = links;
  currentIndex = index;
  lbImg.src    = links[index].href;
  lbImg.alt    = links[index].querySelector('img').alt;
  lightbox.hidden = false;
  document.body.style.overflow = 'hidden';
  lbClose.focus();
}

function closeLightbox() {
  lightbox.hidden = true;
  document.body.style.overflow = '';
  lbImg.src = '';
}

function showPrev() {
  currentIndex = (currentIndex - 1 + currentGroup.length) % currentGroup.length;
  lbImg.src = currentGroup[currentIndex].href;
}

function showNext() {
  currentIndex = (currentIndex + 1) % currentGroup.length;
  lbImg.src = currentGroup[currentIndex].href;
}

if (lightbox) {
  // Abrir al hacer click en imagen
  document.querySelectorAll('.gallery-item__link').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const group  = link.dataset.lightbox;
      const allLinks = [...document.querySelectorAll(`[data-lightbox="${group}"]`)];
      const index  = allLinks.indexOf(link);
      openLightbox(allLinks, index);
    });
  });

  lbClose.addEventListener('click', closeLightbox);
  lbPrev.addEventListener('click', showPrev);
  lbNext.addEventListener('click', showNext);

  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox) closeLightbox();
  });

  document.addEventListener('keydown', (e) => {
    if (lightbox.hidden) return;
    if (e.key === 'Escape')     closeLightbox();
    if (e.key === 'ArrowLeft')  showPrev();
    if (e.key === 'ArrowRight') showNext();
  });
}
